import React, { useState, useEffect } from "react";
import Breadcrumb from "../../atoms/breadcrumb/breadcrumb";
import ShareModal from "../../molecules/share-modal/shareModal";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
import useScrollDetect from "../../../shared/hooks/useScrollDetect";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import DefaultImage from "../../../assets/images/not-found/Icono_vertical_portada_libro.jpg";
import SpotifyIcon from "../../../assets/images/icons/spotify.svg";
import AppleIcon from "../../../assets/images/icons/apple.svg";

import "./headboardPodcastDetail.scss";

interface HeadboardPodcastDetailProps {
  contentful_id?: string;
  breadcrumb: string;
  image?: string;
  date?: string;
  title: string;
  author: string;
  episodes?: string;
  duration?: string;
  links: Array<{
    key: any;
    link: string;
    copy: string;
  }>;
  mmsId: string;
}

const HeadboardPodcastDetail = (props: HeadboardPodcastDetailProps) => {
  const {
    breadcrumb,
    image,
    date,
    title,
    author,
    episodes,
    duration,
    links,
    mmsId,
  } = props;

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [imgError, setimgError] = useState(false);
  const [ellipsisModal, setellipsisModal] = useState(false);
  const [scrollPercent, setScrollPercent] = useState(0);
  const { isScrollActive, refElement } = useScrollDetect();
  const { isBrowser, window, document } = useBrowserMode();

  useEffect(() => {
    isBrowser && document.addEventListener("scroll", onScrollAction);
    return () => {
      isBrowser && document.removeEventListener("scroll", onScrollAction);
    };
  }, []);

  const setIconForLink = (link: string) => {
    if (link.indexOf("spotify") !== -1) {
      return (
        <>
          <img
            className={`o-hb-podcast-detail__top-bar__links__icon gtmDetalle${
              episodes ? "Podcast" : "Episodio"
            }${normalizeTwoWords(title)}EscucharSpotify`}
            src={SpotifyIcon}
            alt="Icono Spotify"
          />
        </>
      );
    } else if (link.indexOf("apple") !== -1) {
      return (
        <>
          <img
            className={`o-hb-podcast-detail__top-bar__links__icon gtmDetalle${
              episodes ? "Podcast" : "Episodio"
            }${normalizeTwoWords(title)}EscucharApple`}
            src={AppleIcon}
            alt="Icono Apple"
          />
        </>
      );
    }
  };

  const toggleModal = () => {
    setIsModalVisible(!isModalVisible);
  };

  const handleErroImage = () => {
    setimgError(true);
  };

  let timerScroll: any;
  const onScrollAction = () => {
    window.clearTimeout(timerScroll);
    timerScroll = setTimeout(() => {
      let windowScroll = window.pageYOffset;
      let contentHeight = document.body.offsetHeight - 1000;
      setScrollPercent((windowScroll * 100) / contentHeight);
    }, 66);
  };

  return (
    <section className="o-hb-podcast-detail" ref={refElement}>
      <Breadcrumb content={breadcrumb} />
      <div className="o-hb-podcast-detail__content">
        <div className="o-hb-podcast-detail__content__left-info">
          <img
            className="o-hb-podcast-detail__content__left-info__image"
            src={image ? (imgError ? DefaultImage : image) : DefaultImage}
            alt={`Portada ${title}`}
            onError={handleErroImage}
          />
          <p className="o-hb-podcast-detail__content__left-info__episodes-duration">
            {episodes ? `${episodes}` : ""}
            {duration ? `${duration}` : ""}
          </p>
          <div className="o-hb-podcast-detail__content__left-info__podcast-icon">
            <div className="content-icon">
              <i className={"icon icon-microphone"} />
            </div>
          </div>
        </div>
        <div className="o-hb-podcast-detail__content__right-info">
          {date && (
            <p className="o-hb-podcast-detail__content__right-info__date">
              {date}
            </p>
          )}
          <h1 className="o-hb-podcast-detail__content__right-info__title">
            {title}
          </h1>
          <p className="o-hb-podcast-detail__content__right-info__author">
            {author}
          </p>
          <ul className="o-hb-podcast-detail__content__right-info__actions">
            <li
              className="o-hb-podcast-detail__content__right-info__actions__action"
              onClick={() => toggleModal()}
            >
              <i
                className={`icon-share o-hb-podcast-detail__content__right-info__actions__action__icon gtmDetalle${
                  episodes ? "Podcast" : "Episodio"
                }${normalizeTwoWords(title)}Compartir`}
              />
              <p
                className={`o-hb-podcast-detail__content__right-info__actions__action__text gtmDetalle${
                  episodes ? "Podcast" : "Episodio"
                }${normalizeTwoWords(title)}Compartir`}
              >
                Compartir
              </p>
            </li>
          </ul>
          <ul className="o-hb-podcast-detail__content__right-info__links">
            {links.map((link, idx) => (
              <li key={idx}>
                <a
                  className={`o-hb-podcast-detail__content__right-info__links__link gtmDetalle${
                    episodes ? "Podcast" : "Episodio"
                  }${normalizeTwoWords(title)}${normalizeTwoWords(link.copy)}`}
                  href={link.link}
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="icon-external-link-alt" />
                  {link.copy}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      {isScrollActive && (
        <>
          <div className="o-hb-podcast-detail__top-bar">
            <div className="o-hb-podcast-detail__top-bar__left-side">
              <div className="o-hb-podcast-detail__top-bar__image hide-on-mobile">
                <img
                  src={image ? (imgError ? DefaultImage : image) : DefaultImage}
                  alt={`Portada ${title}`}
                  onError={handleErroImage}
                />
              </div>
              <div
                className={`o-hb-podcast-detail__top-bar__title ${
                  isScrollActive
                    ? "o-hb-podcast-detail__top-bar__title--shown"
                    : ""
                }`}
              >
                {date && (
                  <p className="o-hb-podcast-detail__top-bar__title__date">
                    {date}
                  </p>
                )}
                <p className="o-hb-podcast-detail__top-bar__title__name">
                  {title}
                </p>
              </div>
            </div>
            <ul className="o-hb-podcast-detail__top-bar__links">
              {links.map((link, idx) => (
                <React.Fragment key={idx}>
                  <li className="hide-on-mobile">
                    <a
                      className={`o-hb-podcast-detail__top-bar__links__link gtmDetalle${
                        episodes ? "Podcast" : "Episodio"
                      }${normalizeTwoWords(title)}${normalizeTwoWords(
                        link.copy
                      )}`}
                      href={link.link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {link.copy}
                    </a>
                  </li>
                  <li key={idx} className="show-on-mobile">
                    <a
                      className={`o-hb-podcast-detail__top-bar__links__link gtmDetalle${
                        episodes ? "Podcast" : "Episodio"
                      }${normalizeTwoWords(title)}${normalizeTwoWords(
                        link.copy
                      )}`}
                      href={link.link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {setIconForLink(link.link)}
                    </a>
                  </li>
                </React.Fragment>
              ))}
              <li className="o-hb-podcast-detail__top-bar__ellipsis">
                <div
                  className={
                    "o-hb-podcast-detail__top-bar__ellipsis__content" +
                    (ellipsisModal
                      ? " o-hb-podcast-detail__top-bar__ellipsis__active-ellipsis"
                      : "")
                  }
                  onClick={() => {
                    setellipsisModal(!ellipsisModal);
                  }}
                >
                  <i className="icon icon-ellipsis-v" />
                </div>
              </li>
            </ul>
            {ellipsisModal && (
              <ul className="o-hb-podcast-detail__top-bar__ellipsis__open hide-on-mobile">
                <li
                  className="o-hb-podcast-detail__top-bar__ellipsis__open__action"
                  onClick={() => toggleModal()}
                >
                  <i
                    className={`icon-share o-hb-podcast-detail__top-bar__ellipsis__open__action__icon gtmDetalle${
                      episodes ? "Podcast" : "Episodio"
                    }${normalizeTwoWords(title)}Compartir}`}
                  />
                  <p
                    className={`o-hb-podcast-detail__top-bar__ellipsis__open__action__text gtmDetalle${
                      episodes ? "Podcast" : "Episodio"
                    }${normalizeTwoWords(title)}Compartir}`}
                  >
                    Compartir
                  </p>
                </li>
              </ul>
            )}
            <div className={`o-hb-podcast-detail__top-bar__scrollbar`}>
              <span style={{ width: `${scrollPercent}%` }}></span>
            </div>
          </div>
          {ellipsisModal && (
            <div className="o-hb-podcast-detail__top-bar__ellipsis__open show-on-mobile">
              <ul className="o-hb-podcast-detail__top-bar__ellipsis__open__content ">
                <li
                  className="o-hb-podcast-detail__top-bar__ellipsis__open__action"
                  onClick={() => toggleModal()}
                >
                  <i
                    className={`icon-share o-hb-podcast-detail__top-bar__ellipsis__open__action__icon gtmDetalle${
                      episodes ? "Podcast" : "Episodio"
                    }${normalizeTwoWords(title)}Compartir}`}
                  />
                  <p
                    className={`o-hb-podcast-detail__top-bar__ellipsis__open__action__text gtmDetalle${
                      episodes ? "Podcast" : "Episodio"
                    }${normalizeTwoWords(title)}Compartir}`}
                  >
                    Compartir
                  </p>
                </li>
              </ul>
            </div>
          )}
        </>
      )}
      <ShareModal
        open={isModalVisible}
        onClose={toggleModal}
        href={window.location.href}
      />
    </section>
  );
};

export default HeadboardPodcastDetail;
